import { DEFAULT_LOCALE, LOCALES } from "@elyxeer/ui";
import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import cs from "./locales/cs.json";
import en from "./locales/en.json";

// Guard against React 19 StrictMode's double mount and Fast Refresh re-evaluating
// this module — `init` is not idempotent.
if (!i18n.isInitialized) {
  void i18n.use(initReactI18next).init({
    resources: { cs: { translation: cs }, en: { translation: en } },
    lng: DEFAULT_LOCALE,
    fallbackLng: DEFAULT_LOCALE,
    supportedLngs: LOCALES,
    ns: ["translation"],
    defaultNS: "translation",
    keySeparator: ".",
    nsSeparator: false, // single namespace — don't treat ":" as a separator
    interpolation: { escapeValue: false }, // React escapes already
    returnNull: false,
    react: { useSuspense: false },
    // Surface any key used in code but missing from a catalogue, during development.
    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (languages, _ns, key) => {
      if (import.meta.env.DEV) {
        console.error(
          `[i18n] missing key "${key}" for ${languages.join(", ")}`,
        );
      }
    },
  });
}

export default i18n;
